import { Chip, makeStyles } from "@material-ui/core";
import { FC } from "react";

interface ChipBlockInterface {
  text: string | undefined;
  theme: "red" | "yellow" | "green" | "gray";
}

export const ChipBlock: FC<ChipBlockInterface> = ({ text, theme }) => {
  const classes = useStyles();
  return <Chip label={text} className={classes[`${theme}Theme`]} />;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(0.5, 1),
  },
  redTheme: {
    background: "#F5AAAA",
    color: "#881414",
  },
  yellowTheme: {
    background: "#F5D87A",
    color: "#7A5200",
  },
  greenTheme: {
    background: "#A8DABC",
    color: "#145E32",
  },
  grayTheme: {},
}));
